import { createContext, useState, useContext, ReactNode } from "react";

const HelpModalContext = createContext<{
  visible: boolean;
  showHelpModal?: () => void;
  hideHelpModal?: () => void;
}>({ visible: false });

export const HelpModalProvider = ({ children }: { children: ReactNode }) => {
  const [visible, setVisible] = useState(false);

  const showHelpModal = () => setVisible(true);
  const hideHelpModal = () => setVisible(false);

  return (
    <HelpModalContext.Provider
      value={{ visible, showHelpModal, hideHelpModal }}
    >
      {children}
    </HelpModalContext.Provider>
  );
};

export const useHelpModal = () => useContext(HelpModalContext);
